import { render, staticRenderFns } from "./shareExpert.vue?vue&type=template&id=cfff0c98&scoped=true&"
import script from "./shareExpert.vue?vue&type=script&lang=js&"
export * from "./shareExpert.vue?vue&type=script&lang=js&"
import style0 from "./shareExpert.vue?vue&type=style&index=0&id=cfff0c98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfff0c98",
  null
  
)

export default component.exports